<template>
  <div>
    <!-- Filters -->
    <app-collapse hover>
      <app-collapse-item title="Filters">
        <regularization-list-filters
          :status-filter.sync="statusFilter"
          :status-options="regularizationStatusOption"
          :created-by-filter.sync="createdByFilter"
          :employee-options="createdByFilterOptions"
          :manager-filter.sync="managerFilter"
          :manager-options="managerOptions"
        />
      </app-collapse-item>
    </app-collapse>
    <!-- Table Container Card -->
    <b-card no-body class="mb-0 mt-2">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-form-checkbox
              v-if="regularizationsMetaData.length && $can('Zircly Admin')"
              class="mr-2"
              v-model="isDeleteMultipleCandChecked"
            >
            </b-form-checkbox>
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              :searchable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-input-group
                v-if="selectedRegularizations.length == 0"
                class="input-group-merge"
              >
                <b-input-group-prepend is-text>
                  <feather-icon icon="SearchIcon" />
                </b-input-group-prepend>
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Search Name"
                />
              </b-input-group>
              <b-button
                v-if="
                  $can('regularization_create') &&
                  selectedRegularizations.length == 0
                "
                variant="primary"
                :to="{ name: 'add-regularize-application' }"
              >
                <span class="text-nowrap">Add Regularization</span>
              </b-button>
              <b-button
                pill
                v-b-modal.modal-review-application
                v-if="
                  $can('Zircly Admin') && selectedRegularizations.length != 0
                "
                class="float-right"
                variant="info"
                :disabled="selectedRegularizations.length == 0"
                >Review {{ selectedRegularizations.length }} Regularization
                Application(s)</b-button
              >

              <b-modal
                id="modal-review-application"
                ref="modalReviewApplication"
                hide-footer
                centered
                @hidden="resetModal"
              >
                <template #modal-header="{ close }">
                  <h2 class="text-center">Review Applications</h2>
                  <feather-icon
                    class="cursor-pointer"
                    icon="XIcon"
                    size="32"
                    @click="close()"
                  />
                </template>

                <div v-if="itemHashId != ''" class="mb-2">
                  <h2>
                    {{ itemUsername }}
                  </h2>
                  <div>{{ itemDates }}</div>
                  <div class="mt-1"><span class="h4 text-dark">Reason:</span> {{ itemReason }}</div>
                </div>

                <form
                  ref="form"
                  @submit.stop.prevent="handleSubmit"
                  class=""
                >
                  <b-form-group
                    label="Remark"
                    label-for="remark-input"
                    invalid-feedback="Remark is required"
                    :state="nameState"
                  >
                    <b-form-textarea
                      id="remark-input"
                      v-model="reviewer_reason"
                      :state="nameState"
                      placeholder="Remark"
                      required
                      rows="4"
                    ></b-form-textarea>
                  </b-form-group>

                  <div
                    v-if="itemHashId == ''"
                    class="d-flex justify-content-center"
                  >
                    <b-button
                      pill
                      variant="success"
                      class="mr-1"
                      :disabled="reviewer_reason == ''"
                      v-on:click="saveMassReview('Approved')"
                    >
                      Accept
                    </b-button>
                    <b-button
                      pill
                      variant="danger"
                      :disabled="reviewer_reason == ''"
                      v-on:click="saveMassReview('Rejected')"
                    >
                      Reject
                    </b-button>
                  </div>
                  <div
                    v-if="itemHashId != ''"
                    class="d-flex justify-content-center"
                  >
                    <b-button
                      pill
                      variant="success"
                      class="mr-1"
                      :disabled="reviewer_reason == ''"
                      v-on:click="saveReview('Approved')"
                    >
                      Accept
                    </b-button>
                    <b-button
                      pill
                      variant="danger"
                      :disabled="reviewer_reason == ''"
                      v-on:click="saveReview('Rejected')"
                    >
                      Reject
                    </b-button>
                  </div>
                </form>
              </b-modal>
            </div>
            <b-button
              v-if="$can('regularization_delete') && false"
              class="float-right"
              variant="danger"
              :disabled="regularizationsDeleteCount == 0"
              @click="confirmDeleteMultipleRecords"
            >
              <span class="text-nowrap"
                >Delete {{ regularizationsDeleteCount }} Regularization</span
              >
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-form-checkbox-group
        id="checkbox-group"
        v-model="selectedRegularizations"
        name="selectedRegularizations"
      >
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="fetchRegularizationList"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(select)="data">
            <div class="text-nowrap">
              <b-form-checkbox :value="data.item.hashid"> </b-form-checkbox>
            </div>
          </template>

          <template #cell(user.name)="data">
            <b-media vertical-align="center">
              <b-link
                v-if="$can('regularization_show')"
                :to="{
                  name: 'view-regularize-application',
                  params: { id: data.item.hashid },
                }"
                class="font-weight-bold d-inline-block text-nowrap"
                v-b-tooltip.hover.v-default
                :title="data.item.user.name"
              >
                {{ data.item.user.name | str_limit(15) }}
              </b-link>
              <span
                v-else
                v-b-tooltip.hover.v-default
                :title="data.item.user.name"
              >
                {{ data.item.user.name | str_limit(15) }}
              </span>
            </b-media>
          </template>

          <template #cell(dates)="data">
            <span
              v-b-tooltip.hover.v-default
              :title="data.item.dates | formatDates"
            >
              {{ data.item.dates | formatDates | str_limit(26) }}
            </span>
          </template>

          <template #cell(from_time)="data">
            {{ data.item.from_time | formatTime }}
          </template>
          <template #cell(to_time)="data">
            {{ data.item.to_time | formatTime }}
          </template>

          <!--Column: Status -->
          <template #cell(status)="data">
            <b-badge
              pill
              :variant="`light-${resolveUserStatusVariant(data.item.status)}`"
              class="text-capitalize"
            >
              {{ data.item.status_label }}
            </b-badge>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <feather-icon
              @click="editRecord(data)"
              v-if="
                $can('regularization_edit') &&
                data.item.status != 1 &&
                data.item.status != 2
              "
              v-b-tooltip.hover
              title="Edit"
              icon="EditIcon"
              size="16"
              class="mr-1 cursor-pointer"
            />
            <feather-icon
              @click="viewRecord(data)"
              v-if="$can('regularization_show')"
              v-b-tooltip.hover
              title="View"
              icon="EyeIcon"
              size="16"
              class="cursor-pointer"
            />

            <b-dropdown
              variant="link"
              size="sm"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>

              <b-dropdown-item
                class="btn-sm p-0"
                v-b-modal.modal-review-application
                v-if="
                  $can('regularization_edit') &&
                  (data.item.reviewer.hashid == auth_user.hashid ||
                    $can('Zircly Admin'))
                "
                @click="confirmReview(data)"
              >
                <feather-icon
                  icon="MessageSquareIcon"
                  size="13"
                  class="mr-50"
                />
                <span>Review</span>
              </b-dropdown-item>

              <b-dropdown-item
                class="btn-sm p-0"
                @click="confirmDeleteRecord(data)"
                v-if="
                  $can('regularization_delete') &&
                  data.item.user.hashid == auth_user.hashid &&
                  data.item.status != 1
                "
              >
                <feather-icon icon="TrashIcon" size="13" class="mr-50" />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-form-checkbox-group>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
              {{ dataMeta.of }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-if="selectedRegularizations.length == 0"
              v-model="currentPage"
              :total-rows="totalRegularizationList"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
            <b-button
              v-else-if="$can('regularization_delete') && false"
              class="float-right"
              variant="danger"
              :disabled="regularizationsDeleteCount == 0"
              @click="confirmDeleteMultipleRecords"
            >
              <span class="text-nowrap"
                >Delete {{ regularizationsDeleteCount }} Regularization</span
              >
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BFormInput,
  BLink,
  BMedia,
  BPagination,
  BRow,
  BTable,
  VBTooltip,
  BFormCheckbox,
  BFormCheckboxGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { onUnmounted, watch, ref } from "@vue/composition-api";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import regularizationStoreModule from "../regularizationStoreModule";
import useRegularizationList from "./useRegularizationList";
import RegularizationListFilters from "./RegularizationListFilters.vue";
import moment from "moment";

export default {
  components: {
    RegularizationListFilters,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BLink,
    BPagination,
    AppCollapse,
    AppCollapseItem,
    vSelect,
    /* eslint-disable */
    ToastificationContent,
    /* eslint-enable */
    BFormCheckbox,
    BFormCheckboxGroup,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  setup() {
    const REFERRAL_APP_STORE_MODULE_NAME = "app-regularizations";
    const isDeleteMultipleCandChecked = ref(false);
    const selectedRegularizations = ref([]);
    const regularizationsDeleteCount = ref(0);

    // Register module
    if (!store.hasModule(REFERRAL_APP_STORE_MODULE_NAME)) {
      store.registerModule(
        REFERRAL_APP_STORE_MODULE_NAME,
        regularizationStoreModule
      );
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(REFERRAL_APP_STORE_MODULE_NAME))
        store.unregisterModule(REFERRAL_APP_STORE_MODULE_NAME);
    });

    const statusOptions = [
      { label: "In Progress", code: 0 },
      { label: "Selected", code: 1 },
      { label: "Rejected", code: 2 },
    ];
    const {
      fetchRegularizationList,
      tableColumns,
      perPage,
      currentPage,
      totalRegularizationList,
      regularizationsMetaData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      resolveUserStatusVariant,
      regularizationStatusOption,
      statusFilter,
      createdByFilter,
      managerFilter,
    } = useRegularizationList();

    watch(isDeleteMultipleCandChecked, (val) => {
      selectedRegularizations.value = [];
      if (val) {
        regularizationsMetaData.value.forEach((regularization) => {
          selectedRegularizations.value.push(regularization.hashid);
        });
      }
    });

    watch(selectedRegularizations, (val) => {
      regularizationsDeleteCount.value = val.length;
    });

    return {
      // Sidebar
      fetchRegularizationList,
      tableColumns,
      perPage,
      currentPage,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      totalRegularizationList,
      // Extra Filters
      statusOptions,
      selectedRegularizations,
      regularizationsDeleteCount,
      isDeleteMultipleCandChecked,
      resolveUserStatusVariant,
      regularizationStatusOption,
      statusFilter,
      createdByFilter,
      regularizationsMetaData,
      managerFilter,
    };
  },
  data() {
    return {
      auth_user: this.$cookies.get("userData"),
      createdByFilterOptions: [],
      reviewer_reason: "",
      itemUsername: "",
      itemDates: "",
      itemHashId: "",
      itemReason: "",
      nameState: null,
      managerOptions: [],
    };
  },
  created() {
    const self = this;
    if (!this.$can("Zircly Admin")) {
      this.tableColumns = this.tableColumns.filter(
        (item) => item.key != "select"
      );
      //this.fetchTeamList();
    }
    const urlParams = new URLSearchParams(window.location.search);
    const userId = urlParams.get('employee_hash_id');
    this.createdByFilter = userId ? userId : ""
    this.fetchEmployeeList();
    this.fetchManagerList();
  },
  methods: {
    fetchManagerList() {
      this.$store
        .dispatch("app/descendantMangers")
        .then((res) => {
          this.managerOptions = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    resetModal() {
      const self = this;
      self.itemUsername = "";
      self.itemDates = "";
      self.itemHashId = "";
      self.itemReason = "";
      self.reviewer_reason = "";
    },
    fetchTeamList() {
      this.$store
        .dispatch("app/fetchTeamList")
        .then((res) => {
          if (res.data.data.length > 0) {
            this.createdByFilterOptions = res.data.data;
          }
        })
        .catch((err) => {
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Fetching Team List failed.",
          //     icon: "BellIcon",
          //     variant: "danger",
          //     text: err.toString(),
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fetching Team List failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: err.toString(),
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
        });
    },
    fetchEmployeeList() {
      this.$store
        .dispatch("app/fetchEmployeeList")
        .then((res) => {
          this.createdByFilterOptions = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    editRecord(data) {
      this.$router
        .push(`/edit/regularize-application/${data.item.hashid}`)
        .catch(() => {});
    },
    viewRecord(data) {
      this.$router
        .push(`/view/regularize-application/${data.item.hashid}`)
        .catch(() => {});
    },
    confirmDeleteRecord(data) {
      this.$swal({
        title: "Are you sure?",
        text: `You want to delete ${data.item.user.name} Application.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRecord(data.item.hashid);
        }
      });
    },
    confirmReview(data) {
      const self = this;
      var myStringArray = data.item.dates.split(",");
      var outputStringArray = [];
      for (var i = 0; i < myStringArray.length; i++) {
        outputStringArray.push(
          moment(String(myStringArray[i])).format("MMM Do YYYY")
        );
      }
      var outputString = outputStringArray.join(", ");

      self.itemUsername = data.item.user.name;
      self.itemDates = outputString;

      self.itemHashId = data.item.hashid;
      self.itemReason = data.item.reason;
      self.reviewer_reason = data.item.reviewer_reason;
    },
    saveReview(status) {
      const self = this;
      const formData = new FormData();
      formData.append("reviewer_reason", self.reviewer_reason);
      formData.append("hashid", self.itemHashId);
      formData.append("status", status);
      self.$store
        .dispatch("app-regularizations/saveReview", formData)
        .then((res) => {
          if (res.data.success) {
            this.refetchData();
            // self.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Review saved successfully",
            //     icon: "BellIcon",
            //     variant: "success",
            //     text: res.data.message,
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Review saved successfully',
                icon: 'BellIcon',
                variant: 'success',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
          } else {
            // self.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Review Update Failed",
            //     icon: "BellIcon",
            //     variant: "danger",
            //     text: res.data.message,
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Review Update Failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
          }
        })
        .catch((error) => {
          // self.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Oops! Review Update Failed",
          //     icon: "BellIcon",
          //     variant: "danger",
          //     text: error,
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Oops! Review Update Failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: error,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
        });
      this.$refs["modalReviewApplication"].hide();
    },
    saveMassReview(status) {
      const self = this;
      const formData = new FormData();
      formData.append("reviewer_reason", self.reviewer_reason);
      formData.append("hashids", self.selectedRegularizations);
      formData.append("status", status);
      let data = {};
      data.url = "regularizations/mass-update-status";
      data.params = formData;
      this.$store
        .dispatch("app/store", data)
        .then((res) => {
          if (res.data.success) {
            this.refetchData();
            // self.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Review saved successfully",
            //     icon: "BellIcon",
            //     variant: "success",
            //     text: res.data.message,
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Review saved successfully',
                icon: 'BellIcon',
                variant: 'success',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });

          } else {
            // self.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Review Update Failed",
            //     icon: "BellIcon",
            //     variant: "danger",
            //     text: res.data.message,
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Review Update Failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
          }
        })
        .catch((error) => {
          // self.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Oops! Review Update Failed",
          //     icon: "BellIcon",
          //     variant: "danger",
          //     text: error,
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Oops! Review Update Failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: error,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
        });
      this.$refs["modalReviewApplication"].hide();
    },
    confirmDeleteMultipleRecords() {
      this.$swal({
        title: "Are you sure?",
        text: `You want to delete ${this.selectedRegularizations.length} Regularization, This cannot be undone.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(
              "app-regularizations/removeMultipleRegularizations",
              this.selectedRegularizations
            )
            .then((res) => {
              this.isDeleteMultipleCandChecked = false;
              this.selectedRegularizations = [];
              if (res.data.success) {
                this.refetchData();
                // this.$toast({
                //   component: ToastificationContent,
                //   props: {
                //     title: "Deleted Successfully.",
                //     icon: "BellIcon",
                //     variant: "success",
                //     text: res.data.message,
                //   },
                // });
                this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Deleted Successfully',
                icon: 'BellIcon',
                variant: 'success',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });

              } else {
                // this.$toast({
                //   component: ToastificationContent,
                //   props: {
                //     title: "Regularization Deletion failed.",
                //     icon: "BellIcon",
                //     variant: "danger",
                //     text: res.data.message,
                //   },
                // });
                this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Regularization Deletion failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
              }
            })
            .catch((err) => console.log(err));
        }
      });
    },
    refetchRegularizationsData() {
      console.log("Added Regularization");
    },
    deleteRecord(id) {
      const self = this;
      this.$store
        .dispatch("app-regularizations/removeRegularization", id)
        .then((res) => {
          if (res.status == "204") {
            // self.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Regularization Deleted",
            //     icon: "BellIcon",
            //     variant: "success",
            //     text: "Regularization Deleted Successfully.",
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Regularization Deleted',
                icon: 'BellIcon',
                variant: 'success',
                text: 'Regularization Deleted Successfully',
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
          } else {
            // self.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Regularization Deletion failed.",
            //     icon: "BellIcon",
            //     variant: "danger",
            //     text: res.data.message,
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Regularization Deletion failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
          }
          self.refetchData();
        })
        .catch((err) => {
          // self.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Regularization Deletion failed.",
          //     icon: "BellIcon",
          //     variant: "danger",
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: `Regularization Deletion failed`,
                icon:'ErrorIcon',
                variant : 'danger',
                hideClose: true,
                
              },
                  },
                  {
              timeout : 3000,
              position : 'bottom-center',
              toastClassName:"error-info",
              hideProgressBar : true,
                  })
          console.error(err);
        });
    },
    openWindow(link) {
      window.open(link);
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
